<template>
  <section class="home-bed">
    <div class="img-bed">
      <title-bar title="公交卡新办"></title-bar>
    </div>

    <div class="menu-list">
      <div class="list-bed">
        <div @click="goRouter('newNormal')"
             class="list-li ">
          <img src="../assets/img/cardNewadd/card_ptk.png" />

        </div>
        <div @click="goRouter('newStudent')"
             class="list-li ">
          <img src="../assets/img/cardNewadd/card_xsk.png" />

        </div>

      </div>

    </div>

  </section>
</template>

<script>
import TitleBar from '@/components/TitleBar'
export default {
  name: 'home',
  data () {
    return {
      loading: true
    }
  },
  components: {
    TitleBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.menu-list {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  > .list-bed {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // flex-wrap: wrap;
    width: 100%;
    border-top: 1px solid #e8ebf0;
    padding: 0 32px;

    > .list-li {
      width: calc(50% - 13px);
      height: 160px;
      margin-top: 32px;
      display: flex;
      img {
        width: 100%;
      }
    }
  }
}
</style>
